import i18n from '@/main';

export default class StatusCar {
    static get AT() {
        return i18n.t('mensagens.comuns.ativo');
    }

    static get PE() {
        return i18n.t('mensagens.comuns.pendente');
    }

    static get CA() {
        return i18n.t('mensagens.comuns.cancelado');
    }

    static get SU() {
        return i18n.t('mensagens.comuns.suspenso');
    }

    static getByName(name) {
        if (!name) return;
        name = name.toUpperCase();
        return StatusCar[name];
    }
}
